import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import calendar from "assets/social/calendar.svg";
import yahoo from "assets/social/yahoo.png";
import outlook from "assets/social/outlook.svg";
import iCal from "assets/social/iCal.png";
import * as zIndexes from "zIndexes.module.scss";

export const useStyles = makeStyles<Theme>((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(0.5),
    top: theme.spacing(0.5),
    color: theme.palette.events.blueSecondary,
  },
  addToCalendarModal: {
    zIndex: zIndexes.popover,
    "& .MuiDialogTitle-root": {
      "& h2": {
        display: "flex",
        flex: 1,
        alignItems: "center",
        position: "relative",

        "& button": {
          position: "absolute",
          right: -10,
          zIndex: 0,
        },
      },
    },

    "& .MuiDialogContent-root": {
      display: "flex",
      paddingBottom: "3rem",
      justifyContent: "space-around",
      overflow: "hidden",
      gap: theme.spacing(1),

      [theme.breakpoints.down("sm")]: {
        flexWrap: "wrap",
      },
    },
  },
  calLink: {
    height: "7.5rem",
    backgroundRepeat: "no-repeat",
    minWidth: 100,
    backgroundPosition: "center 1rem",
    backgroundSize: "4.5rem",
    lineHeight: "15rem",
    whiteSpace: "nowrap",
    textAlign: "center",
    color: "var(--Black)",
    textDecoration: "none",
    fontSize: 14,
    fontFamily: "DM Sans",
    fontWeight: 400,

    [theme.breakpoints.down("xs")]: {
      backgroundSize: "3rem",
      backgroundPosition: "top",
      height: "7rem",
      margin: "auto",
      width: "50%",
      minWidth: 0,
      lineHeight: "8rem",
      flex: "50%",
      fontSize: "0.875rem",
    },

    "&:hover": {
      textDecoration: "underline",
    },
  },
  google: {
    backgroundImage: `url(${calendar})`,
  },
  yahoo: {
    backgroundImage: `url(${yahoo})`,
  },
  outlook: {
    backgroundImage: `url(${outlook})`,
  },
  iCal: {
    backgroundImage: `url(${iCal})`,
  },
}));
